import React from "react";
import { IconButton, Tooltip as MuiTooltip } from "@mui/material";
import DarkModeOutlinedIcon from "@mui/icons-material/DarkModeOutlined";
import LightModeOutlinedIcon from "@mui/icons-material/LightModeOutlined";
import { useWiserTheme } from "../../hooks/useWiserTheme";
import Tooltip from "../Tooltip";
import {
  SidebarThemeButton,
  SidebarThemeIcon,
  SidebarThemeLabel,
} from "../Sidebar/style";

type DarkModeToggleProps = {
  variant?: "header" | "sidebar";
  compact?: boolean;
};

const DarkModeToggle: React.FC<DarkModeToggleProps> = ({
  variant = "header",
  compact = false,
}) => {
  const { darkModeActive, switchColorMode, tokens } = useWiserTheme();
  const tooltip = darkModeActive ? "Açık moda geç" : "Gece moduna geç";
  const label = darkModeActive ? "Açık Mod" : "Gece Modu";

  const icon = darkModeActive ? (
    <LightModeOutlinedIcon sx={{ fontSize: 20 }} />
  ) : (
    <DarkModeOutlinedIcon sx={{ fontSize: 20 }} />
  );

  if (variant === "sidebar") {
    const button = (
      <SidebarThemeButton
        type="button"
        className="wiser-sidebar-theme-toggle"
        onClick={switchColorMode}
        aria-label={tooltip}
        $compact={compact}
      >
        <SidebarThemeIcon>{icon}</SidebarThemeIcon>
        {!compact && <SidebarThemeLabel>{label}</SidebarThemeLabel>}
      </SidebarThemeButton>
    );

    if (compact) {
      return (
        <Tooltip text={tooltip} position="right" fullWidth>
          {button}
        </Tooltip>
      );
    }

    return button;
  }

  return (
    <MuiTooltip title={tooltip}>
      <IconButton
        onClick={switchColorMode}
        aria-label={tooltip}
        size="small"
        sx={{
          color: darkModeActive ? tokens.textSecondary : "rgba(255, 255, 255, 0.92)",
          borderRadius: "6px",
          transition: "background-color 0.2s ease",
          "&:hover": {
            backgroundColor: darkModeActive
              ? tokens.navHoverBg
              : "rgba(255, 255, 255, 0.1)",
          },
        }}
      >
        {icon}
      </IconButton>
    </MuiTooltip>
  );
};

export default DarkModeToggle;
